// extracted by mini-css-extract-plugin
export default {"selectContainer":"FieldRecurringPeriod_selectContainer__d0ZUM","labelContainer":"FieldRecurringPeriod_labelContainer__0KsBQ"};